import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import styles from './VehicleDetailsContainer.module.css';

export const Wrapper = createComponent('main', {
  className: cx(styles.wrapper, 'bg-background-default')
});

export const ContentWrapper = createComponent('div', {
  className:
    'mx-auto max-w-[1440px] px-0 md:px-3xl lg:px-[clamp(var(--spacing-4xl),calc((100vw-1440px)/2+84px),84px)]'
});

export const DealershipContentWrapper = createComponent(ContentWrapper, {
  className: 'md:pt-4xl'
});
